import React from "react"
import Seo from "../components/seo"
import Layout from "../components/layout"
import { Link } from "gatsby"
import "../styles/pc/page/recruit.scss"
import "../styles/sp/page/recruit.scss"

export default function RecruitPage() {
  return (
    <Layout>
      <Seo
        type="article"
        title="採用"
        description="「人と組織と社会のつながりを再生し、未来へつなぐ」。これからの社会や企業のあり方を考えた時、もっと社会、会社、人とのつながりを生み出したいと想い、この新たなミッションに至りました。私たちはこの想いに賛同し、一緒に歩む仲間を探しています。"
        bobyClassName="menu14"
        path="recruit"
      />
      <div className="wrapper recruit">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/recruit" className="current">Recruit</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
        <div className="catch1">
          <div className="catch1_in">
            <div className="catch_title">
              <h2 className="maintitle"><span>Recruit</span></h2>
              <p className="subtitle"><span>採用</span></p>
            </div>
          </div>{/* catch_in */}
        </div>{/* /catch1 */}
        {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="main">
        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
          <div className="contents_01">
            <div className="contents_in">
              <div className="padding_sp">{/* スマホのみ隙間 */}
                <div className="inner_title">
                    <div className="step_contents">
                      <div className="flex_wrap step_wrap">
                        <Link to='/recruit/member'>
                          <div className="flex_contents">
                            <div className="step_box">
                                Member
                                <span>想いでつながる社内メンバーを募集</span>
                            </div>
                          </div>
                        </Link>
                        <Link to='/recruit/partner'>
                          <div className="flex_contents">
                            <div className="step_box">
                                Partner
                                <span>組織開発の支援者となりませんか?</span>
                            </div>
                          </div>
                        </Link>
                    </div>
                  </div>
                </div>
              </div>{/* padding_sp スマホのみ隙間 */}
            </div>{/* contents_in */}
          </div>{/* /contents */}
          {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">Recruit - </span><span className="txt">採用情報</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}
